var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"text-primary mb-base"},[_vm._v(_vm._s(_vm.$t('profile.profile')))]),_c('profile-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }